import useDefinedContext from "hooks/useDefinedContext";
import AreaChartStoreContext from "../contexts/AreaChartStoreContext";

interface UseAreaChartProps {}

function useAreaChart(props?: UseAreaChartProps) {
  return useDefinedContext(AreaChartStoreContext);
}

export default useAreaChart;
